import { formatMoney } from '@betterment/js-runtime';
import { Box, Text } from '@betterment/samba-react';

import { TradeItem } from '../../transactionTypes/Trade';
import { TransferItem } from '../../transactionTypes/Transfer';

type TradeRowItem = TransferItem | TradeItem;

export const TradeRow: React.FC<{ item: TradeRowItem }> = ({ item }) => {
  const name = item.security?.name ?? 'Cash';
  const symbol = item.security?.symbol;
  const amount = formatMoney(item.amount);

  const { sharePrice, shares } = item;

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Text variant="text100" color="text.weak">
          {symbol ? `${symbol} • ${name}` : name}
        </Text>
      </Box>

      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Text variant="text50" color="text.weak">
            Amount
          </Text>
          <Text variant="text50" color="text.weak">
            {amount}
          </Text>
        </Box>

        {shares && (
          <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text variant="text50" color="text.weak">
              Shares
            </Text>
            <Text variant="text50" color="text.weak">
              {shares}
            </Text>
          </Box>
        )}

        {sharePrice && (
          <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text variant="text50" color="text.weak">
              Share price
            </Text>
            <Text variant="text50" color="text.weak">
              {formatMoney(sharePrice)}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};
